<template>
  <ChartHover class="hover" @mousemove="handleMouseMove" @mouseleave="handleMouseLeave">
    <slot />

    <CircleElement v-if="showCircle" :key="serie" :cx="x" :cy="y" r="5" :fill="stroke" />
  </ChartHover>
</template>

<script>
import { scaleQuantize } from 'd3-scale';
import {
  pipe,
  filter,
  propEq,
  map,
  omit,
  values,
  flatten,
  uniq,
  find,
  toPairs,
  head,
  ifElse,
  always,
  length,
  equals,
} from 'ramda';

import { CircleElement, ChartHover } from './areaChart.styles';
import { YEAR_FIELD } from '../../../constants';

export default {
  components: { CircleElement, ChartHover },
  props: {
    labelsScale: Function,
    yScale: Function,
    stroke: String,
    data: Array,
    serie: String,
    xProp: String,
    chartWidth: Number,
  },
  inject: ['cursorPoint'],
  data() {
    return {
      x: 0,
      y: 0,
      showCircle: false,
      hoveredLabel: '',
      closest: '',
    };
  },
  computed: {
    inverseLabelsScale() {
      const domain = this.labelsScale.domain();
      const range = this.labelsScale.range();
      return scaleQuantize()
        .domain(range)
        .range(domain);
    },
  },
  methods: {
    resetHoveredLabel() {
      this.showCircle = false;
    },
    handleMouseMove(event) {
      const { clientX, clientY } = event;
      const { x, y } = this.cursorPoint(clientX, clientY);

      const hoveredLabel = this.inverseLabelsScale(x);
      const yPos = this.yScale.invert(y);
      const yValues = pipe(
        filter(propEq(YEAR_FIELD, hoveredLabel)),
        map(pipe(omit([YEAR_FIELD]), values)),
        flatten,
        uniq
      )(this.data);

      const closest = yValues.reduce((a, b) => (Math.abs(b - yPos) < Math.abs(a - yPos) ? b : a));
      const label = pipe(
        find(propEq(YEAR_FIELD, hoveredLabel)),
        omit([YEAR_FIELD]),
        toPairs,
        ifElse(pipe(length, equals(1)), always('Total'), pipe(find(propEq(1, closest)), head))
      )(this.data);

      this.x = this.labelsScale(hoveredLabel);
      this.y = this.yScale(closest);
      this.showCircle = true;
      const showOnLeft = this.chartWidth / 2 < this.x;
      const horizontalOffset = showOnLeft ? -20 : 20;

      if (hoveredLabel !== this.hoveredLabel && this.closest !== closest) {
        this.$emit('enter', {
          id: `${hoveredLabel}-${closest}`,
          data: {
            serie: label,
            value: closest,
          },
          targetBox: {
            x: this.x + horizontalOffset,
            y: this.y - 30,
            width: 1,
            height: 1,
            directPosition: true,
            showOnLeft,
          },
        });

        self.hoveredLabel = hoveredLabel;
        self.closest = closest;
      }
    },
    handleMouseLeave() {
      this.resetHoveredLabel();
    },
  },
};
</script>
